/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuInput } from '@neutron/react';

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  width: 26em;
  margin-top: 12px;
`;

export const StatusContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
`;

export const CategorySelect = styled.select`
  appearance: none;
  width: 97%;
  height: 42px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #939393;
  box-sizing: border-box;
  border-radius: 5px;
`;

export const StyledCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
  &:checked ~ span {
    background-color: var(--primary-60);
  }
  &:checked ~ span:after {
    display: block;
  }
`;
